import agreementConstants from './agreementConstants';

const initialState = {
  agreements: [],
}

export default function agreementsReducer(state = initialState, action) {
  switch (action.type) {
    case agreementConstants.GET_AGREEMENTS_SUCCESS:
      return {
        agreements: action.agreements,
      };
    case agreementConstants.GET_AGREEMENTS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
